<template>
	<div
		class="fixed top-0 z-[1000] flex h-14 w-full items-center justify-center gap-1 bg-gradient-to-r from-[#22DF96] via-[#01BB83] to-[#01BB83] px-2 sm:px-8 md:h-8"
	>
		<span class="text-center text-base font-medium text-white">
			<IcoLightning class="inline h-5 w-5 fill-yellow-300" />
			Go green & earn $100 charging credit.
			<CarbarLink
				href="/cars/subscribe/electric"
				text="Switch to EV"
				class="inline-block"
				font-size="text-base"
				font-weight="font-medium"
				text-color="text-white hover:text-gray-100"
				underline-color="underline-white hover:decoration-gray-100"
			/>
			today!
			<CarbarLink
				href="/terms-and-conditions#august-go-green-promotion"
				text="T&C"
				class="inline-block"
				font-size="text-base"
				font-weight="font-medium"
				text-color="text-white hover:text-gray-100"
				underline-color="underline-white hover:decoration-gray-100"
			/>
			apply.
		</span>
	</div>
</template>

<script setup>
import CarbarLink from '@/components/links/CarbarLink.vue'
import IcoLightning from '@/assets/svg/common/ico-lightning.svg'
</script>
